import apiService from "./apiService";
import AppConstants from "../appConstants";

class UserService {
    getAllUsers(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CONTRIB, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_USER_CONTRIB}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerUser(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateUser(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteUser(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_USER_CONTRIB}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    checkUserInfo(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CHECK_INFO, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    sendNewPassword(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CONTRIB_SEND_NEW_PASSWORD, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    sendEmailFirstAccess(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_SEND_EMAIL_FIRST_ACCESS, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_USER_CONTRIB_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserFormDetail(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CONTRIB_FORM_DETAIL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getUserConfig(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_USER_CONTRIB_CONFIG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    // sendPassword(form, params) {
    //     return new Promise((resolve, reject) => {
    //         apiService.post(AppConstants.URL_RESET_PASSWORD, form, params)
    //             .then(response => resolve(response))
    //             .catch(error => reject(error));
    //     });
    // }

    changePassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_CHANGE_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    resetPassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_RESET_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    forgotPassword(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_FORGOT_PASSWORD, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateUserConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE_USER_CONFIG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateSendNewsConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE_SENDNEWS_CONFIG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    updateMyAccountGeneral(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_GENERAL, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    updateMyAccountShortcuts(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_SHORTCUT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    updateMyAccountConfig(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_CONTRIB_UPDATE_MY_ACCOUNT_CONFIG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    attendance(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_USER_ATTENDANCE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new UserService();
